import { useQuery } from '@apollo/client';
import { GET_PICKUP_ROUTE_BY_ID, GetPickupRouteByIdResponse, GetPickupRouteByIdVariables } from '../graphql/queries/getPickupRouteById';

export const usePickupRouteById = (id: number | null) => {
  const { data, loading, error, refetch } = useQuery<GetPickupRouteByIdResponse, GetPickupRouteByIdVariables>(
    GET_PICKUP_ROUTE_BY_ID,
    {
      variables: { id: id! },
      skip: !id,
      fetchPolicy: 'network-only', // 每次都从网络获取最新数据
    }
  );

  const route = data?.getPickupRouteWithDriverInfoById;

  return {
    route,
    loading,
    error,
    refetch
  };
};
